<template>
  <div id="install-device">
    <div class="module-search">
      <span>设备状态：</span>
      <el-select v-model="search.online" clearable placeholder="请选择状态" class="status-select">
        <el-option
          v-for="item in statusList"
          :key="item.value"
          :label="item.code"
          :value="item.value"
        />
      </el-select>

      <span style="margin-left: 40px;">安装位置：</span>
      <el-input
        v-model="search.installPosition"
        placeholder="请输入安装位置"
        clearable
        class="input-with-select"
      ></el-input>

      <span style="margin-left: 40px;">产品型号：</span>
      <el-select v-model="search.groupId" class="status-select" clearable placeholder="请选择产品型号">
        <el-option v-for="item in deviceGroup" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>

      <el-button class="add-btn" type="primary" :disabled="tableLoading" @click="handleSearch">
        查询
      </el-button>
      <el-dropdown v-if="isEdit" class="search-btn" :title="moretitle" @command="handleCommand">
        <el-button type="primary" :disabled="!isMore">
          指令操作<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-if="firstGroupId === 2" command="onoff">
            负载开关
          </el-dropdown-item>
          <el-dropdown-item v-if="firstGroupId === 2" command="frequency">
            上报频率
          </el-dropdown-item>
          <el-dropdown-item v-if="firstGroupId !== 2" command="max">
            触发值
          </el-dropdown-item>
          <el-dropdown-item v-if="firstGroupId !== 2" command="mode">
            工作模式
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <!-- <el-button
        class="search-btn"
        type="primary"
        :disabled="!isMore"
        @click="handleSetBtn"
        plain
      >
        更多操作 <i class="el-icon-arrow-down"></i>
      </el-button> -->
      <!-- <el-button class=".search-btn add-btn" type="primary" icon="el-icon-plus" @click="handleClickAdd">添加</el-button> -->
    </div>

    <div class="table-box">
      <el-table
        ref="multipleTable"
        v-loading="tableLoading"
        :data="tableList"
        :show-overflow-tooltip="true"
        class="module-main"
        style="width: 100%"
        header-row-class-name="table-header"
        row-class-name="table-row"
        @selection-change="handleSelection"
        @select-all="selectAll"
        @select="rowSelect"
      >
        <el-table-column v-if="isEdit" type="selection" :selectable="selectable"></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="name4Company"
          label="设备名称"
          align="center"
        />
        <el-table-column show-overflow-tooltip prop="groupName" label="产品型号" align="center" />
        <el-table-column show-overflow-tooltip prop="code" label="设备编码" align="center" />
        <el-table-column show-overflow-tooltip prop="imei" label="IMEI" align="center" />
        <el-table-column
          show-overflow-tooltip
          prop="installPositionRemark"
          label="位置备注"
          align="center"
        />
        <!-- <el-table-column show-overflow-tooltip prop="brand" label="品牌" align="center" /> -->
        <!-- <el-table-column show-overflow-tooltip prop="mac" label="MAC地址" align="center" /> -->
        <el-table-column
          show-overflow-tooltip
          prop="installPosition"
          label="安装位置"
          align="center"
        />
        <el-table-column prop="installTime" label="安装时间" align="center" minWidth="120" />
        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            <span :class="scope.row.online ? 'green' : 'red'">
              {{ scope.row.online ? '在线' : '离线' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="140">
          <template slot-scope="scope">
            <span
              class="table-history"
              @click="handleClickHistory(scope.row, scope.row.id)"
            >指令历史</span>
            <span class="table-detail" @click="handleClickDetail(scope.row.id)">编 辑</span>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        :total="pagination.total"
        :page-size="pagination.pageSize"
        :current-page="pagination.pageIndex"
        background
        class="pagination"
        layout="prev, pager, next"
        @current-change="changePageData"
      />
    </div>

    <el-dialog
      :visible.sync="addUserDialogVisibility"
      custom-class="add-user-dialog"
      title="设备详情"
      width="960px"
      @closed="handleAddUserDialogClosed"
    >
      <div class="input-info">
        <span class="title"><span>*</span>安装时间:</span>
        <el-input v-model="addUserDialogData.installTime" disabled placeholder="请输入内容" />
      </div>
      <div class="input-info">
        <span class="title"><span>*</span>设备名称:</span>
        <el-input
          v-model="addUserDialogData.name4Company"
          placeholder="请输入"
          :disabled="!isEdit"
        />
      </div>
      <div class="input-info" :title="addUserDialogData.code">
        <span class="title"><span>*</span>产品型号:</span>
        <el-select v-model="addUserDialogData.groupId" disabled clearable placeholder="请选择">
          <el-option
            v-for="item in deviceGroup"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </div>
      <div class="input-info" :title="addUserDialogData.code">
        <span class="title"><span>*</span>设备编码:</span>
        <el-input v-model="addUserDialogData.code" disabled placeholder="请输入" />
      </div>
      <div class="input-info">
        <span class="title"><span>*</span>品牌:</span>
        <el-input v-model="addUserDialogData.brand" disabled placeholder="请输入" />
      </div>
      <div class="input-info">
        <span class="title"><span>*</span>GUID:</span>
        <el-input v-model="addUserDialogData.guid" disabled placeholder="请输入" />
      </div>
      <div class="input-info">
        <span class="title"><span>*</span>IMEI:</span>
        <el-input v-model="addUserDialogData.imei" disabled placeholder="请输入" />
      </div>
      <div class="input-info">
        <span class="title"><span>*</span>MAC:</span>
        <el-input v-model="addUserDialogData.mac" disabled placeholder="请输入" />
      </div>
      <div class="input-info" :title="addUserDialogData.installPosition">
        <span class="title"><span>*</span>安装位置:</span>
        <el-input v-model="addUserDialogData.installPosition" disabled placeholder="请输入" />
      </div>
      <div class="input-info">
        <span class="title"><span>*</span>安装坐标:</span>
        <el-input v-model="addUserDialogData.lnglat" disabled placeholder="请输入" />
      </div>
      <div class="input-info">
        <span class="title"><span>*</span>位置备注:</span>
        <el-input
          v-model="addUserDialogData.installPositionRemark"
          placeholder="请输入"
          :disabled="!isEdit"
        />
      </div>
      <div class="input-info">
        <span class="title"><span>*</span>摄像机:</span>
        <el-select v-model="cameraId" filterable clearable placeholder="请选择摄像机">
          <el-option
            v-for="item in cameraList"
            :key="item.id"
            :label="item.cameraName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
      <div class="input-info">
        <span class="title"><span>*</span>告警设备:</span>
        <el-select
          v-model="addUserDialogData.otherDeviceIdList"
          reserve-keyword
          collapse-tags
          filterable
          multiple
          placeholder="请选择告警设备"
        >
          <el-option
            v-for="item in deviceList"
            :key="item.id"
            :label="item.name + ` (${item.groupName})`"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
      <div class="input-infos">
        <span class="title"><span>*</span>现场图片:</span>
        <div class="img-list">
          <el-image
            v-for="(item, index) in addUserDialogData.installPics"
            :key="index"
            :src="item"
            :preview-src-list="addUserDialogData.installPics"
            style="width: 150px;height:150px;marginRight:10px;"
          ></el-image>
          <!-- <img :src="item" alt="" v-for='item in addUserDialogData.installPics'> -->
          <img
            v-if="!addUserDialogData.installPics.length"
            class="nopic"
            src="/static/img/common/noImage.png"
          >
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          v-if="isEdit"
          class="certain-btn"
          icon="el-icon-edit"
          type="primary"
          @click="submitEdit"
        >保 存</el-button>
      </span>
    </el-dialog>

    <!-- 设置设备参数start -->
    <el-dialog
      :visible.sync="setDialogVisibility"
      custom-class="add-user-dialog"
      title="设置设备参数"
      width="640px"
      @closed="handleSetDialogClosed"
    >
      <div class="box">
        <div v-if="orderType === 'max'" class="input-info">
          <span class="title"><span>*</span>触发值:</span>
          <!-- <el-input v-model="deviceParams.threshold"  placeholder="请输入" /> -->
          <el-input-number
            v-model="deviceParams.threshold"
            :precision="0"
            :step="1"
            :max="16"
            :min="1"
          ></el-input-number>
        </div>
        <div v-if="orderType === 'mode'" class="input-info">
          <span class="title"><span>*</span>工作模式:</span>
          <el-select v-model="deviceParams.workMode" @change="handleChangeMode">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div v-if="orderType === 'mode'" class="input-info">
          <span class="title"><span>*</span>上报频率:</span>
          <!-- <el-input v-model="deviceParams.frequency" placeholder="请输入" /> -->
          <el-input-number
            v-model="deviceParams.frequency"
            :precision="0"
            :step="1"
            :max="99"
            :min="1"
          ></el-input-number>
          <span class="unit">{{ deviceParams.workMode === '默认模式' ? '小时' : '秒' }}</span>
        </div>
        <div v-if="orderType === 'onoff'">
          <div class="onoff">
            负载开关
          </div>
          <el-radio-group v-model="onoffOrder.value">
            <el-radio :label="1">
              开
            </el-radio>
            <el-radio :label="0">
              关
            </el-radio>
          </el-radio-group>
        </div>
        <div v-if="orderType === 'frequency'">
          <div class="onoff">
            上报频率
          </div>
          <el-input-number
            v-model="onoffOrder.value"
            :precision="0"
            :step="1"
            :max="99"
            :min="1"
          ></el-input-number>
        </div>
      </div>

      <div v-if="onoffOrder.type !== 1" class="tip-box">
        <img src="/static/img/common/tip.png" alt="">
        <p>{{ tipText }}</p>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button class="certain-btn" type="primary" @click="handleSet">设置</el-button>
      </span>
    </el-dialog>
    <!-- 设置设备参数end -->

    <!-- 指令历史列表start -->
    <el-drawer
      ref="recordDrawer"
      :title="`设备名称：${name4Company}`"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="done => done()"
    >
      <div v-if="currentRow.groupId === 1" class="current-box">
        <h5>当前指令</h5>
        <p>
          <span>触发值</span>
          <span>{{ recordCurrent.alarmRange }}</span>
        </p>
        <p>
          <span>工作模式</span>
          <span>{{ recordCurrent.model }}</span>
        </p>
        <p>
          <span>数据上报频率</span>
          <span>{{ recordCurrent.pubtime }}</span>
        </p>
      </div>
      <div class="table2-box">
        <h5>指令历史列表</h5>
        <el-table v-loading="commandLoading" :data="commandList" :height="table2Height">
          <el-table-column
            property="date"
            label="发送指令时间"
            align="center"
            minWidth="110"
          ></el-table-column>
          <el-table-column property="commandName" label="指令名称" align="center"></el-table-column>
          <el-table-column property="commandValue" label="指令值" align="center"></el-table-column>
        </el-table>
      </div>
    </el-drawer>
    <!-- 指令历史列表end -->
  </div>
</template>

<script>
import { formatDateTime } from '@/utils/objectUtil'
import { roleNames } from '@/config.js'
import { mapState } from 'vuex'
import { otherDevice, cameraList, deviceInfoSave } from '@/views/HomePage/service'
export default {
  name: 'InstallDevice',
  data () {
    return {
      path: {
        setParamsUri: '/api/command-record/send',
        listUri: '/api/device-info/list-install',
        recordListUri: '/api/command-record/record-list',
        recordUri: '/api/command-record/record-info',
      },
      tableLoading: true,
      search: {
        online: '',
        installPosition: '',
        groupId: '',
      },
      statusList: [{ value: 1, code: '在线' }, { value: 0, code: '离线' }],
      // 列表样式
      tableList: [],
      // 分页数据
      pagination: {
        // 一共多少页
        pageCount: 1,
        // 第几页
        pageIndex: 1,
        // 一页显示多少个
        pageSize: 10,
        // 总个数
        total: 0,
      },
      cameraId: '',
      // 添加人员弹窗数据
      addUserDialogData: {
        name4Company: '',
        code: '',
        brand: '',
        guid: '',
        imei: '',
        mac: '',
        installPosition: '',
        installPics: '',
        otherDeviceIdList: [],
      },
      addUserDialogVisibility: false,
      // 所有节点列表数据
      nodeListData: [],
      // 所有角色列表数据
      roleListData: [],
      userDeptsList: [],
      isEdit: false,
      isMore: false,
      isMax: false,
      setDialogVisibility: false,
      deviceParams: {
        workMode: '默认模式',
        threshold: 1,
        frequency: 1,
      },
      options: [{ value: '默认模式', label: '默认模式' }, { value: '连续模式', label: '连续模式' }],
      ids: '', // 选择的设备-设置参数
      moretitle: '请先选择设备！',
      drawer: false,
      name4Company: '',
      commandList: [],
      commandOptions: [], // 指令字典
      commandLoading: true,
      firstGroupId: null, // 第一次选择的表行 groupId,  1: 哨兵二代, 2: 瞭望者
      // 瞭望者指令参数
      onoffOrder: {
        type: null, // 1 设置负载开关, 2 设置上报频率
        value: 1, // 关联onoffOrder.type  负载开关: 0关, 1开. 上报频率: 取值范围1-99
      },
      orderType: null, // 指令类型
      tipText: '',
      tip: {
        max: '可配置1-16，默认值为3；数值越大，触发设备报警需要的力度越大。',
        mode: {
          默认模式:
            '可配置1-99；设备经过一定时间后，主动上报一次数据，其余时间休眠。设置的时间越短，设备电量损耗越快。默认时间4小时。',
          连续模式:
            '可配置1-99；设备经过设置的时间后，主动上报一次数据，该模式下设备永不休眠，设备电量损耗最大，不建议长时间处于该模式。默认时间5秒。',
        },
      },
      currentRow: {},
      recordCurrent: {
        alarmRange: '',
        model: '',
        pubtime: '',
      },
      table2Height: document.documentElement.clientHeight - 214,

      deviceList: [],
      cameraList: [],
    }
  },
  computed: {
    ...mapState(['deviceGroup']),
  },
  created () {
    let {
      pagination: { pageIndex, pageSize },
    } = this
    this.getListReq({ pageIndex, pageSize })
    this.getRoleAndMana()
    this.getCommandOptions()
    otherDevice('3-4', 0).then(res => {
      // 其他设备告警设备, 这里暂时写死 groupidList 和 type
      this.deviceList = res.data.list
    })
    cameraList().then(res => {
      this.cameraList = res.data.list
    })
  },
  mounted () {
    this.initSet()
    this.allowSelectGroupIds = [1, 2]
  },
  methods: {
    rowSelect (selection, row) {
      if (this.firstGroupId == null) {
        this.firstGroupId = row.groupId // 记录第一次选择的 groupId,  以禁止其他不同的 groupId 复选框
      }
      if (selection.length === 0) {
        this.firstGroupId = null
      }
    },
    // 允许瞭望者和哨兵二代选择
    selectable (row) {
      if (this.allowSelectGroupIds.includes(row.groupId)) {
        if (this.firstGroupId == null) {
          return true
        } else {
          if (this.firstGroupId === row.groupId) {
            return true
          } else {
            return false
          }
        }
      } else {
        return false
      }
    },

    getListReq (params) {
      this.tableLoading = true
      this.$http.get(this.path.listUri, { ...params, type: 0 }).then(res => {
        this.tableLoading = false
        if (res.code === 'success') {
          let { list, pageCount, total } = res.data
          let listTemp = list.map(val => {
            val.installTime = formatDateTime(new Date(val.installTime), 'yyyy-MM-dd HH:mm:ss')
            return val
          })
          this.tableList = listTemp
          this.pagination.pageCount = pageCount
          this.pagination.total = total
        }
      })
    },
    /**
     * @description: 获取指令字典- 暂时没用
     * 工作模式 1
     * 触发值 2
     * 默认模式数据上传频率 3
     * 连续工作模式数据上传频率 4
     * @return       {undefind} [undefind]
     */
    getCommandOptions () {
      this.$http.post('/api/json/getDict', { dictType: 'all' }).then(res => {
        if (res.code === 'success') {
          let { list } = res.data

          let tempStr = list.find(val => val.device_command).values
          let tempObj = tempStr && JSON.parse(tempStr)
          let commandOptions = new Map()

          // alarmRange、normal_pubtime、serial_pubtume
          for (let [key, value] of Object.entries(tempObj)) {
            if (value === 3 || value === 4) key = '上传频率'
            commandOptions.set(value, key)
          }

          this.commandOptions = commandOptions
        }
      })
    },
    // 选择要设置的参数
    handleCommand (type) {
      this.setDialogVisibility = true
      this.isMax = type === 'max'
      this.orderType = type
      if (type === 'onoff') {
        this.onoffOrder.type = 1
      } else if (type === 'frequency') {
        this.onoffOrder.type = 2
      }
      this.tipText = type === 'max' ? this.tip.max : this.tip.mode['默认模式']
    },
    // 切换工作模式
    handleChangeMode (e) {
      this.tipText = this.tip.mode[e]
    },
    handleSetDialogClosed () {
      this.setDialogVisibility = false
    },

    handleOnoffSet () {
      let data = this.onoffOrder
      this.$http.post('/api/command-record/sendLookout', {
        ...data,
        deviceIds: this.ids,
      }).then(res => {
        if (res.code === 'success') {
          this.setDialogVisibility = false
          this.$refs.multipleTable.clearSelection()
          this.firstGroupId = null
          this.$message({ message: '指令发送成功', type: 'success' })
        } else {
          this.$message.error(`指令发送失败：${res.msg}`)
        }
      })
    },
    /**
     * @description: 修改设备参数
     * @return       null
     */
    handleSet () {
      if (this.orderType === 'onoff' || this.orderType === 'frequency') {
        return this.handleOnoffSet()
      }
      let { frequency, threshold, workMode } = this.deviceParams
      let params = {
        deviceIds: this.ids,
      }
      if (this.isMax) {
        // 触发值
        params.type = 2
        params.value = threshold
      } else {
        // 上传频率
        if (workMode === '默认模式') {
          params.type = 3
          params.value = frequency
        } else {
          params.type = 4
          params.value = frequency
        }
      }

      this.$http.post(this.path.setParamsUri, params).then(res => {
        if (res.code === 'success') {
          this.setDialogVisibility = false
          this.$refs.multipleTable.clearSelection()
          this.firstGroupId = null
          this.$message({ message: '指令发送成功', type: 'success' })
        } else {
          this.$message.error(`指令发送失败：${res.msg}`)
        }
      })
    },
    selectAll (selection) {
      this.$refs.multipleTable.clearSelection()
    },
    /**
     * @description: 改变table选择状态时的触发函数
     * @param        {Array} selection 表示选中的设备信息列表
     * @return       {undefint}   [undefint]
     */
    handleSelection (selection) {
      this.isMore = false
      this.moretitle = '请先选择设备！'

      if (!selection.length) return

      this.isMore = true
      this.moretitle = ''

      this.ids = selection.reduce((total, item) => [...total, item.id], []).join(',')
    },
    // 获取设备详情
    handleClickDetail (id) {
      let loadObj = this.$loading({ target: document.querySelector('.add-user-dialog') })
      this.addUserDialogVisibility = true
      this.cameraId = null
      // 获取设备详情
      this.$http.get('/api/device-info/show', { id }).then(res => {
        loadObj.close()
        if (res.code === 'success') {
          let data = res.data
          data.lnglat = `${data.installLng}, ${data.installLat}`
          data.installTime = formatDateTime(new Date(data.installTime), 'yyyy-MM-dd HH:mm:ss')
          data.installPics = data.installPics ? data.installPics.split(',') : []
          this.addUserDialogData = data
          if (data.oldCameraIdList && data.oldCameraIdList.length > 0) {
            this.cameraId = data.oldCameraIdList[0]
          }
          if (data.oldOtherDeviceIdList) {
            this.addUserDialogData.otherDeviceIdList = data.oldOtherDeviceIdList
          }
        }
      })
    },
    /**
     * @description: 指令历史
     * 1. command = 1, model=0,normal_pubtime= 1，=>正常模式，频率1h
     * 2. command = 1, model=1,serial_pubtime= 1，=>连续模式，频率1s
     * 3. command = 2, 没有model, alarmRande, => 告警值
     * @param        {[type]} deviceId     [description]
     * @return       {[type]}              [description]
     */
    handleClickHistory (row, deviceId) {
      this.currentRow = row
      this.name4Company = row.name4Company
      this.drawer = true
      this.commandLoading = true
      // 当前指令
      this.getCurrentRecord(deviceId)

      this.$http.get(this.path.recordListUri, { deviceId }).then(res => {
        if (res.code === 'success') {
          this.commandLoading = false
          let { list } = res.data
          // 指令值的key,自己扣出来的，数据格式不规范
          // let commandKey = ['', '', 'alarmRange', 'normal_pubtime', 'serial_pubtime']

          let temp = list.map(({ createTime, content }) => {
            // console.log(JSON.parse(content))
            let date = createTime && formatDateTime(new Date(createTime), 'yyyy-MM-dd HH:mm:ss')
            let str = content
            if (content.replace(/ /g, '').slice(-2, -1) === ',') {
              const index = content.lastIndexOf(',')
              str = content.slice(0, index) + content.slice(index + 1)
            }
            let { command, ...temps } = JSON.parse(str)
            let [commandName, commandValue] = ['--', '--']
            const commandNames = ['触发值', '默认模式', '连续模式', '负载开关', '上报频率']
            if (row.groupId === 1) {
              if (command === 2) {
                commandName = '触发值'
                commandValue = temps.alarmRange
              } else {
                let unit = { '0': '小时', '1': '秒' }
                commandName = temps.model === 0 ? '默认模式' : '连续模式'
                commandValue =
                  (temps.model === 0 ? temps.normal_pubtime : temps.serial_pubtime) +
                  unit[temps.model] || ''
              }
            } else if (row.groupId === 2) {
              if (command === 1) {
                commandName = commandNames[3]
                commandValue = temps.sw_state === 0 ? '关' : '开'
              } else {
                commandName = commandNames[4]
                commandValue = temps.pubtime
              }
            }

            return { date, commandName, commandValue }
          })
          this.commandList = temp
        }
      })
    },
    // 获取当前指令
    getCurrentRecord (deviceId) {
      this.recordCurrent = { alarmRange: '', model: '', pubtime: '' }

      this.$http.get(this.path.recordUri, { deviceId }).then(res => {
        if (res.code === 'success') {
          let { list } = res.data
          list.forEach(({ content }) => {
            let str = content
            if (content.replace(/ /g, '').slice(-2, -1) === ',') {
              const index = content.lastIndexOf(',')
              str = content.slice(0, index) + content.slice(index + 1)
            }
            let { command, ...record } = JSON.parse(str)
            if (command === 2) {
              this.recordCurrent.alarmRange = record.alarmRange
            } else if (command === 1) {
              // 看487行注释
              let { model } = record
              let unit = { '0': '小时', '1': '秒' }
              let modelIndex = ['默认模式', '连续模式']
              let modelKey = ['normal_pubtime', 'serial_pubtime']
              this.recordCurrent.model = modelIndex[model] || ''
              this.recordCurrent.pubtime = record[modelKey[model]] + unit[model] || ''
            }
          })
        }
      })
    },
    handleAddUserDialogClosed () {
      this.addUserDialogVisibility = false
    },
    changePageData (e) {
      this.firstGroupId = null
      let { online, installPosition } = this.search

      let {
        pagination: { pageSize },
      } = this
      this.pagination.pageIndex = e

      this.getListReq({ pageIndex: e, pageSize, online, installPosition })
    },
    handleSearch () {
      this.firstGroupId = null
      let { online, installPosition, groupId } = this.search
      this.pagination.pageIndex = 1
      let {
        pagination: { pageIndex, pageSize },
      } = this
      this.getListReq({ pageIndex, pageSize, online, installPosition, groupId })
    },

    submitEdit () {
      let name = this.addUserDialogData.name4Company
      let remark = this.addUserDialogData.installPositionRemark
      if (name.trim() === '') {
        this.$message({ message: '设备名称不能为空', type: 'warning' })
        return
      }
      if (remark.trim() === '') {
        this.$message({ message: '位置信息不能为空', type: 'warning' })
        return
      }
      // 设备修改信息参数
      let params = {
        id: this.addUserDialogData.id,
        cameraIdList: [this.cameraId],
        otherDeviceIdList: this.addUserDialogData.otherDeviceIdList,
        name4Company: name,
        installPositionRemark: remark,
      }
      this.deviceInfoSave(params)
    },
    // 添加摄像机和告警设备
    deviceInfoSave (data) {
      deviceInfoSave(data).then(res => {
        if (res.code === 'success') {
          this.$message.success('修改成功')
          this.handleSearch() // 重新搜索数据
          this.addUserDialogVisibility = false
        } else {
          this.$message.error(res.msg || '修改失败')
        }
      })
    },
    // handleDelete (ids) {
    //   this.$http.post('/api/device-info/del', { ids }).then(res => {
    //     if (res.code === 'success') {
    //       this.$message({ message: '删除成功', type: 'success' })
    //       this.getListReq({ pageIndex: 1, pageSize: 10 })
    //     } else {
    //       this.$message({ message: '删除失败', type: 'success' })
    //     }
    //   })
    // },
    // 只有系统管理员及超级管理员才可修改设备名称、位置备注的显示操作
    getRoleAndMana () {
      let roles = this.$store.state.roles.map(({ name }) => name)
      let isEdit = roles.includes(roleNames.admin) || roles.includes(roleNames.system)
      this.isEdit = isEdit
    },
    // 初始化一些数据和操作判断
    initSet () {
      // 动态计算指令历史侧边栏的高度，并设置列表滚动高度
      window.onresize = () => {
        this.table2Height = document.documentElement.clientHeight - 214
      }
    },
  },
}
</script>

<style lang="less" scoped>
#install-device {
  /deep/ .el-table__header-wrapper  .el-checkbox{
    display:none; // 禁用全选
  }
  .module-search {
    margin-top: 20px;
    .input-with-select {
      width: 200px;
    }
    span {
      margin-right: 5px;
      font-size: 14px;
      color: #666;
    }

    /deep/ .el-select {
      width: 90px;
    }

    /deep/ .el-input {
      input {
        padding-right: 0px;

        &::-webkit-input-placeholder {
          font-size: 14px;
        }
      }
    }

    .status-select {
      width: 149px;

      /deep/ .el-input__inner {
        height: 36px;
        border-radius: 2px;
        font-size: 14px;
        color: #333;
      }
    }

    .content-input {
      width: 280px;
      margin-left: 50px;

      /deep/ .el-input-group__prepend {
        border-radius: 2px;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;

        .el-input__inner {
          width: 80px;
          height: 36px;
          border-radius: 2px !important;
        }
      }

      /deep/ .el-input__inner:nth-child(2) {
        width: 200px;
        height: 36px;
        border-radius: 2px;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }
    }

    /deep/ .search-btn {
      float: right;
      margin-right: 10px;
      //   padding: 10px 25px;
      //   border-radius: 3px;
      //   margin-left: 50px;
      //   border: 1px solid #5294d6;
      //   color: #5294d6;
      //   background: #fff;

      //   &:hover {
      //     background-color: fade(#5294d6, 10);
      //     color: #5294d6;
      //   }
    }
    .add-btn {
      float: right;
    }
  }

  .table-box {
    margin-top: 20px;
    .module-main {
      .delete-tag {
        color: #f06366;
        text-decoration: underline;
        margin-left: 3px;
        cursor: pointer;
      }

      .green {
        color: #4dd292;
      }

      .red {
        color: #f06366;
      }

      .blue-btn {
        width: 72px;
        background-color: #5294d6;
        // margin-left: 5px;

        &:hover {
          background-color: fade(#5294d6, 85);
        }
      }

      .red-btn {
        background-color: #f06366;
        margin-left: 5px;

        &:hover {
          background-color: fade(#f06366, 80);
        }
      }

      .look-details {
        color: #5294d6;
        text-decoration: underline;
        cursor: pointer;
      }

      /deep/ .table-header {
        color: #333;
        font-size: 14px;
        font-weight: bold;

        th {
          // height: 40px !important;
          // padding: 0px;
          text-align: center !important;
          line-height: 25px;
          background-color: #e9f0fa;
        }
      }

      /deep/ .table-row {
        color: #333;
        font-size: 14px;

        .numbering {
          color: #5294d6;
          text-decoration: underline;
          cursor: pointer;
        }

        td {
          padding: 12px 0;
        }
      }
    }
    .table-detail {
      color: #409eff;
      cursor: pointer;
    }
    .table-history {
      cursor: pointer;
      border: 1px solid #409eff;
      color: #409eff;
      margin-right: 10px;
      padding: 0px 5px;
      border-radius: 4px;
    }
    .pagination {
      padding: 31px 0;
      height: 32px;
      text-align: center;
      font-weight: normal;

      /deep/ .number {
        background-color: #fff;
        border: 1px solid #e1e1e1;
        padding: 2px 5px;
        height: 32px;
        min-width: 32px;
      }

      /deep/ .active {
        border: none;
        background-color: #4078dd;
      }

      /deep/ .btn-prev {
        width: 32px;
        height: 32px;
      }

      /deep/ .btn-next {
        width: 32px;
        height: 32px;
      }

      /deep/ .more {
        width: 32px;
        height: 32px;
        line-height: 35px;
      }
    }
  }
  .current-box,
  .table2-box {
    > h5 {
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 5px;
      text-align: left;
      margin-left: 15px;
      &::before {
        display: inline-block;
        content: '';
        width: 0;
        height: 14px;
        border: 2px solid #409eff;
        margin-right: 5px;
        vertical-align: middle;
      }
    }
  }
  .current-box {
    text-align: center;
    margin-bottom: 15px;
    > p {
      font-size: 14px;
      display: inline-block;
      width: 32%;
      border-right: 1px solid #ccc;
      vertical-align: top;
      &:last-child {
        border-right: none;
      }
      > span {
        display: block;
        font-size: 13px;
        height: 24px;
        line-height: 24px;
        color: #17a05d;
        font-weight: bold;
        &:first-child {
          font-size: 14px;
          color: #333;
        }
      }
    }
  }

  /deep/ .add-user-dialog,
  /deep/ .modify-user-data-dialog {
    .el-input-number {
      width: 252px;
      margin-left: 8px;
    }
    .el-dialog__header {
      height: 40px;
      padding: 0px;
      line-height: 40px;
      text-indent: 20px;
      background-color: #214f88;
    }

    .el-dialog__headerbtn {
      margin-top: -6px;
    }

    .el-dialog__header .el-dialog__title {
      font-size: 16px;
      color: #fff;
    }

    .el-dialog__body {
      padding: 30px 20px 30px 55px;
      // min-height: 485px;
    }

    .input-infos {
      .title {
        text-align: right;
        display: inline-block;
        width: 90px;
        margin-right: 10px;
        vertical-align: top;
        & > span {
          display: none;
          color: red;
        }
      }
      .img-list {
        display: inline-block;
        // img {
        //   width: 150px;
        //   height: 150px;
        //   margin-right: 10px;
        // }
        .nopic {
          width: 80px;
          height: 80px;
          border: 1px dashed #ccc;
          padding: 35px;
        }
      }
    }
    .onoff {
      margin-bottom: 30px;
    }
    .input-info {
      display: inline-block;
      margin-bottom: 10px;
      width: 400px;
      .unit {
        margin-left: 10px;
      }
      .title {
        text-align: right;
        display: inline-block;
        width: 90px;
        // margin-right: 14px;

        & > span {
          display: none;
          color: red;
          margin-right: 3px;
        }
      }

      .el-input {
        width: 240px;
        margin-left: 10px;

        input {
          height: 36px;
        }
      }

      .el-cascader {
        .el-cascader__label {
          text-indent: 13px;
        }
      }

      &.long {
        box-sizing: border-box;
        clear: both;
        width: 100%;
        margin-left: 0px;
        padding-right: 85px;

        .el-input {
          width: 720px;
        }
      }

      .info-content {
        color: #c4c3c3;
        font-size: 12px;
      }

      .el-select__tags {
        text-align: left;
        padding-left: 15px;
      }
    }

    .radio-info {
      float: left;
      margin-bottom: 13px;
      height: 36px;
      line-height: 36px;
      width: 320px;

      &:nth-child(3) {
        margin-left: 33px;
      }

      &:nth-child(4) {
        margin-left: 160px;
      }

      .el-radio-group {
        margin-left: 10px;
      }
    }

    .tip-box {
      margin-top: 20px;
      img {
        width: 18px;
        vertical-align: middle;
      }
      p {
        vertical-align: middle;
        display: inline-block;
        font-size: 12px;
        margin-left: 10px;
        color: #aaa;
        width: 80%;
      }
    }
  }
  /deep/ :focus {
    outline: 0;
  }
  /deep/ .el-drawer {
    min-width: 390px;
  }
  // /deep/ .el-drawer__body {
  //   overflow: auto;
  // }
}
</style>
